"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var getImportanceBadgeStyles = function getImportanceBadgeStyles(importance) {
  if (!importance) {
    return {
      backgroundColor: "#F3F4F6",
      color: "#6B7280"
    };
  }
  switch (importance.toLowerCase()) {
    case "high":
      return {
        backgroundColor: "#FEF2F2",
        color: "#DC2626"
      };
    case "medium":
      return {
        backgroundColor: "#FEF3C7",
        color: "#92400E"
      };
    case "low":
      return {
        backgroundColor: "#ECFDF5",
        color: "#059669"
      };
    case "draft":
      return {
        backgroundColor: "#F3F4F6",
        color: "#6B7280"
      };
    default:
      return {
        backgroundColor: "#F3F4F6",
        color: "#6B7280"
      };
  }
};
var PlaybookRuleCard = function PlaybookRuleCard(_ref) {
  var _rule$importance;
  var rule = _ref.rule,
    _onClick = _ref.onClick;
  var badgeStyles = getImportanceBadgeStyles((_rule$importance = rule.importance) !== null && _rule$importance !== void 0 ? _rule$importance : null);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "relative flex flex-col gap-[10px] px-2 pt-1 pb-2 bg-white rounded-md cursor-pointer transition-all duration-300 ease-out active:translate-y-[2px] border-b border-[#EDEBE8]",
    onClick: function onClick() {
      return _onClick(rule);
    },
    role: "button",
    tabIndex: 0,
    "aria-label": "".concat(rule.name, " \u2014 ").concat(rule.importance || "Draft", " importance"),
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        _onClick(rule);
      }
    },
    "data-sentry-component": "PlaybookRuleCard",
    "data-sentry-source-file": "PlaybookRuleCard.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex justify-between items-center gap-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex items-center gap-3 flex-1",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex flex-col flex-1 items-start gap-2 cursor-pointer py-1 -my-1",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "flex items-center gap-2",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "font-normal text-base leading-[150%] tracking-[0.01em] text-[#171715] flex-1 align-middle",
              children: [rule.name, rule.isManagedRule && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: "bg-background-primary-canvas text-primary px-1 py-0.5 rounded-full text-xs font-normal inline-flex items-center border border-primary ml-1",
                children: "Managed"
              })]
            })
          }), rule.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "font-normal text-xs leading-[120%] tracking-[0.04em] text-[#171715] align-middle overflow-hidden line-clamp-2",
            children: rule.description
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "inline-flex items-center px-2 py-1 rounded-1 text-[11px] font-medium capitalize flex-shrink-0",
        style: badgeStyles,
        children: rule.importance || "Draft"
      })]
    }), rule.tags && rule.tags.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex items-center gap-2 flex-wrap",
      children: rule.tags.map(function (tag) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "inline-flex items-center px-2 py-0.5 bg-[#F3F4F6] rounded text-[11px] text-[#6B7280] font-normal",
          children: tag
        }, tag);
      })
    })]
  });
};
var _default = exports.default = PlaybookRuleCard;